import CreditCardInfo from './credit-card-info';

export default CreditCardInfo;
